import { Card } from "antd";
import { Pie, PieChart, ResponsiveContainer, Legend, Cell, Tooltip } from "recharts";
import { PieChartOutlined } from "@ant-design/icons";

const SpendingChart = ({ spendingData }: any) => {
  const totalAmount = spendingData.categories.reduce((sum: any, item: any) => sum + item.amount, 0);
  const chartData = spendingData.categories.map((item: any, index: any) => ({
    name: item.category,
    value: Number(((item.amount / totalAmount) * 100).toFixed(1)),
    amount: item.amount,
    count: item.count,
    color: `hsl(${(index * 137.5) % 360}, 70%, 50%)`,
  }));

  return (
    <Card
      title={
        <div className="flex items-center gap-2 text-gray-800">
          <PieChartOutlined className="text-orange-500" />
          Spending Breakdown
        </div>
      }
      className="border border-gray-300"
    >
      <div className="h-[320px] relative">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart margin={{ bottom: 20 }}>
            <Tooltip
              cursor={{ fill: "rgba(0,0,0,0.05)", opacity: 0.1 }}
              contentStyle={{
                backgroundColor: "white",
                border: "1px solid #d1d5db",
                borderRadius: "0.5rem",
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              }}
              itemStyle={{ color: "#374151" }}
              formatter={(value, name, props) => [
                `${value}%`,
                `$${props.payload.amount}`,
                `${props.payload.count} items`,
              ]}
            />
            <Pie
              data={chartData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="45%"
              innerRadius={60}
              outerRadius={110}
              strokeWidth={2}
              paddingAngle={5}
            >
              {chartData.map((entry: any) => (
                <Cell key={entry.name} fill={entry.color} />
              ))}
            </Pie>
            <Legend
              iconSize={8}
              iconType="circle"
              layout="horizontal"
              verticalAlign="bottom"
              align="center"
              wrapperStyle={{ fontSize: "11px", color: "#4b5563", paddingTop: "8px" }}
            />
          </PieChart>
        </ResponsiveContainer>

        {/* Bottom left overlay */}
        <div className="absolute bottom-4 left-4 text-left pointer-events-none">
          <div className="text-gray-600 text-xs mb-1">Essential/Discretionary</div>
          <div className="text-orange-500 text-2xl font-bold">
            {spendingData.essential_to_discretionary_ratio.toFixed(1)}
          </div>
        </div>
      </div>
    </Card>
  );
};

export default SpendingChart;
